import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueGtm from "vue-gtm";
import "./assets/customizer.scss";
import { normalizeBuilderPreviewParams } from "./utils/builderPreview";
import { recoverCustomizerUrl } from "./utils/customizerUrlRecovery";
import axios from "axios";
import { initSentry } from "./utils/sentry";
import { installAxiosReporting } from "./utils/httpReporting";
import { initializeMetaTracking } from "./utils/metaTracking";

let wakeLock = null;

const activateWakeLock = async () => {
    if (!("wakeLock" in navigator)) return;

    try {
        wakeLock = await navigator.wakeLock.request("screen");
        wakeLock.addEventListener("release", () => {
        });
    } catch (err) {
        // sentry-ignore: screen wake lock is optional; browsers may refuse it
        void err;
    }
};

const handleVisibilityChange = () => {
    if (document.visibilityState === "visible" && wakeLock) {
        activateWakeLock();
    }
};

document.addEventListener("click", activateWakeLock, { once: true });
document.addEventListener("visibilitychange", handleVisibilityChange);

async function bootstrap() {
    const app = createApp(App);
    initSentry(app, router);
    installAxiosReporting(axios);
    initializeMetaTracking();
    await recoverCustomizerUrl();
    normalizeBuilderPreviewParams();

    if (process.env.VUE_APP_DEV_MODE !== "true") {
        app.use(VueGtm, {
            id: "GTM-5SD5X2BC",
            vueRouter: router,
            enabled: true,
            debug: false,
            trackOnNextTick: false,
        });
    } else {
        app.use(VueGtm, {
            id: "GTM-DEVMODE",
            vueRouter: router,
            enabled: true,
            debug: false,
            trackOnNextTick: false,
        });
    }

    app.use(router);
    app.mount("#app");
}

bootstrap();
